import React, { Component } from 'react';
import { Link, withRouter } from 'react-router';
import _ from 'lodash';
import { Field } from 'redux-form';
import classNames from 'classnames';
import { Grid, Row, Col, Panel, Button, Input, Tabs, Tab, Textarea, Image } from 'react-bootstrap';
import Selection from '../Common/selection';
import AfterAddonField from '../Common/afterAddonField';
import DisabledWeightField from '../Common/weightField';
import { PriceField, DisabledPriceField } from '../Common/priceField';
import InputField from '../Common/inputField';
import { Translate, Localize } from 'react-redux-i18n';

export default class ProductArrays extends Component {
    constructor() {
        super();
        this.state = {
            // Only show the current Product
            currentProduct: -1
        };
    }

    componentWillMount() {
    }

    getNetWeight(id) {
        const { products } = this.props;
        const index = _.findIndex(products, { 'Product_id': id });
        return parseFloat(products[index].NetWeight);
    }

    getShippingWeight(id) {
        const { products } = this.props;
        const index = _.findIndex(products, { 'Product_id': id });
        return parseFloat(products[index].ShippingWeight);
    }

    // If the priceType is selected to be CIF, calculate the CIF Price.

    getCIFPrice(index) {
        const { priceType, productsValue, totalPrice } = this.props;
        if (priceType == 'CIF' && productsValue[index].TotalPrice && totalPrice != '0.0000') {
            let CIFPrice = parseFloat(this.props.totalCost || 0) * parseFloat(productsValue[index].TotalPrice || 0) / parseFloat(totalPrice);
            CIFPrice = CIFPrice / parseFloat(productsValue[index].Quantity || 0) + parseFloat(productsValue[index].FOBUnitPrice || 0);
            CIFPrice = CIFPrice.toFixed(2);
            return CIFPrice;
        } else return 0;
    }

    productHeader(index) {
        const { currentProduct } = this.state;
        const { calculatedProducts, productsValue } = this.props;
        const descriptionClass = classNames({ 'hidden': index == currentProduct }, 'pull-right');
        return (
            <div  onClick={ (e) => {
                e.preventDefault();
                if (index != currentProduct) this.setState({ currentProduct: index });
                else this.setState({ currentProduct: -1 });
            } } >
                <div>
                    {index == currentProduct && <label style={{ cursor: "pointer" }} >Product Information</label>}
                    {index != currentProduct && calculatedProducts[index] &&
                        <label style={{ cursor: "pointer" }} >{calculatedProducts[index].Title }</label>}
                    {index != currentProduct && productsValue && <div className="pull-right" > {productsValue[index].Quantity} </div> }
                </div>
            </div>
        )
    }

    render() {
        const { fields, productNumOptions, productNameOptions, refNumOptions, productsValue, products, calculatedProducts } = this.props;
        return (
            <Row><Col sm={ 12 }>
                <Row><Col sm={ 12 }>
                    {fields.map((Product, index) =>
                        <Panel header={this.productHeader(index) } key={ index }
                            collapsible expanded={index == this.state.currentProduct}>
                            <Row><Col sm={ 12 }>
                              <h4><Translate value="product_information" /></h4>
                            </Col></Row>
                            <hr/>
                            <Row>
                                <Col sm={ 5 }>
                                    <Row><Col sm={ 12 }>
                                        <div className="form-group">
                                          <label><Translate value="product_num" /></label>
                                            <Field name={`${Product}.Product_id`} component={Selection} options={productNumOptions}/>
                                        </div>
                                    </Col></Row>
                                    <Row><Col sm={ 12 }>
                                        <div className="form-group">
                                          <label><Translate value="product_name" /></label>
                                            <Field name={`${Product}.Product_id`} component={Selection} options={productNameOptions}/>
                                        </div>
                                    </Col></Row>
                                </Col>
                                <Col sm={ 7 }>
                                  <label><Translate value="description" /></label>
                                    <Field name="PickupWarehouse" component="Textarea" className="form-control" style={{ minHeight: '130px' }}/>
                                </Col>
                            </Row>
                            <br/>
                              <h4><Translate value="product_unit_weight_price" /></h4>
                            <hr/>
                              {calculatedProducts[index] && !calculatedProducts[index].Product_id && <h4 className="centerStyle"><Translate value="please_select_a_product" /></h4>}
                            {calculatedProducts[index] && calculatedProducts[index].Product_id &&
                                <div>
                                    <Row>
                                      <label className="col-sm-3 centerStyle" ><Translate value="convert_item_price" />: </label>
                                        <Col sm={ 3 }>
                                            <Field name={`${Product}.CIFUnitPrice`} component={ DisabledPriceField } V={this.getCIFPrice(index) }/>
                                        </Col>
                                        <label className="col-sm-3 centerStyle" ><Translate value="unit_price" />: </label>
                                        <Col sm={ 3 }>
                                            <Field name={`${Product}.FOBUnitPrice`} component={ PriceField }/>
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row>
                                      <label className="col-sm-3 centerStyle" ><Translate value="quantity" />: </label>
                                        <Col sm={ 3 }>
                                            <Field name={`${Product}.Quantity`} component={ AfterAddonField }/>
                                        </Col>
                                        <label className="col-sm-3 centerStyle" ><Translate value="unit_of_measure" />: </label>
                                        <Col sm={ 3 } className="centerStyle">
                                          { calculatedProducts[index].UnitOfMeasure }
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row>
                                      <label className="col-sm-3 centerStyle" ><Translate value="total_price" />: </label>
                                        <Col sm={ 9 }>
                                            {calculatedProducts[index] &&
                                                <div>
                                                    <Field name={`${Product}.TotalPrice`}
                                                        component={ DisabledPriceField }
                                                        V={calculatedProducts[index].TotalPrice }/>
                                                </div> }
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row>
                                      <label className="col-sm-3 centerStyle" ><Translate value="total_net_weight" />: </label>
                                        <Col sm={ 9 }>
                                            {calculatedProducts[index] &&
                                                <div>
                                                    <Field name={`${Product}.TotalNetWeight`}
                                                        component={ DisabledWeightField }
                                                        V={calculatedProducts[index].TotalNetWeight }/>
                                                </div> }
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row>
                                      <label className="col-sm-3 centerStyle" ><Translate value="total_shipping_weight" />: </label>
                                        <Col sm={ 9 }>
                                            {calculatedProducts[index] &&
                                                <div>
                                                    <Field name={`${Product}.TotalShippingWeight`}
                                                        component={ DisabledWeightField }
                                                        V={calculatedProducts[index].TotalShippingWeight }/>
                                                </div> }
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row>
                                      <label className="col-sm-3 centerStyle" ><Translate value="est_sale_price" />: </label>
                                        <Col sm={ 9 }>
                                            <Field name={`${Product}.EstSalePrice`} component={ PriceField }/>
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row>
                                      <label className="col-sm-3 centerStyle" ><Translate value="total_est_sale_price" />: </label>
                                        <Col sm={ 9 }>
                                            {calculatedProducts[index] &&
                                                <div>
                                                    <Field name={`${Product}.EstSaleTotal`}
                                                        component={ DisabledPriceField }
                                                        V={calculatedProducts[index].EstSaleTotal }/>
                                                </div> }
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row><Col sm={1}/>
                                        <Button className="col-sm-10 btn btn-danger" type="button" onClick={() => {
                                            fields.remove(index)  // remove from index
                                          } }><i/> <Translate value="remove_this_product" />.
                                        </Button>
                                    </Row>
                                </div>}
                        </Panel>) }
                    <Row>
                        <Button type="button"
                            className="btn btn-info col-sm-12"
                            onClick={() => {
                                fields.push({});
                                this.setState({ currentProduct: fields.length });
                            }
                          } ><i/> <Translate value="add_another_product" />
                        </Button>
                    </Row>
                </Col></Row>
            </Col></Row>
        )
    }
}



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/productArray.jsx